import React, {useEffect} from 'react';
import "../assets/css/Components.css"

const IntroSlides = ({img}) => {

    useEffect(() => {

    }, []);

    return (
        <div className="header-container fa-flex-col w-100">
            <div className="intro-slides-container position-relative">
                <img src={img} alt="cover_image" className="slide-img-cover"/>
            </div>
        </div>
    );
};

export default IntroSlides;